import { useEffect, useState } from 'react';
import './App.css';
import { FormspreeProvider } from '@formspree/react';
import { useForm } from '@formspree/react';

function App() {
  const [state, handleSubmit] = useForm('xqkovgpp');
  const [success, setSuccess] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);

  function handleFileChange(event) {
    const fileInput = event.target;
    setFileUploaded(fileInput.files && fileInput.files[0] ? true : false);
  }

  useEffect(() => {
    if (state.succeeded) {
      setSuccess(true);
    }
  }, [state]);

  const formJsx = (
    <div>
      <div className='custom-form__p'>
        <p className='custom-form__title'>Request for Private Lending</p>
        <p className='custom-form__description'>
          Looking for quick financing options for your real estate investment?
          Fill out the request form below to explore the possibilities of
          securing a bridge loan or hard money loan tailored to your needs.
        </p>
      </div>
      <form
        encType="multipart/form-data"
        onSubmit={handleSubmit}
        className="custom-form"
        action="post"
      >
        <div className="custom-form__row">
          <input
            className="custom-form__field"
            type="text"
            placeholder="Name"
            name="name"
            required
          />

          <input
            className="custom-form__field"
            type="text"
            placeholder="Name of Company"
            name="company_name"
            required
          />
        </div>
        <div className="custom-form__row">
          <input
            className="custom-form__field"
            type="number"
            placeholder="Phone Number"
            name="phone"
            required
          />

          <input className="custom-form__field hidden" />
        </div>
        <div className="custom-form__row">
          <input
            className="custom-form__field"
            type="text"
            placeholder="Describe your project"
            name="loan_target"
            required
          />
        </div>
        <div className="custom-form__row custom-form__row-last">
          <input
            className="custom-form__field"
            type="number"
            placeholder="Approximate Loan Value"
            name="loan_value"
            required
          />
          <input
            className="custom-form__field"
            type="text"
            placeholder="Desired Term Length"
            name="loan_term"
            required
          />
        </div>

        <div className="last-row">
          <div>
            <label
              htmlFor="file-input"
              className={fileUploaded ? 'icon-dis' : 'icon'}
            />
            <input
              className="invisible"
              id="file-input"
              type="file"
              name="file"
              accept="image/png, image/jpeg, application/pdf"
              onChange={handleFileChange}
            />
          </div>
          <button
            className={state.submitting ? 'button button-disabled' : 'button'}
            type="submit"
            disabled={state.submitting}
          >
            submit
          </button>
        </div>
      </form>
    </div>
  );

  const messageSuccess = (
    <div className="message">Your request has been sent.</div>
  );

  return (
    <FormspreeProvider project="xqkovgpp">
      <div className="app">{success ? messageSuccess : formJsx}</div>
    </FormspreeProvider>
  );
}

export default App;
